import { render } from "./subjects-list.vue?vue&type=template&id=1050827e&scoped=true"
import script from "./subjects-list.vue?vue&type=script&lang=js"
export * from "./subjects-list.vue?vue&type=script&lang=js"

import "./subjects-list.vue?vue&type=style&index=0&id=1050827e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1050827e"]])

export default __exports__